
import React from "react";
import FieldInputMask from "../fieldInputMask";

const FieldInputNumeroClabe = ({colMd, colSm, label, name, onChange, onBlur, value, keyFilter, rows, disabled,formatType,error, errors,required}) => {


    return (
        <>

          {label   &&
           <FieldInputMask maskVariable="(999999999999999999)" name={name} label={label} colMd={colMd} errors={errors} required={required} disabled={disabled}
            value={ value }  onChange={onChange} onBlur={onBlur}/>
          }

           {!label  &&
            <FieldInputMask maskVariable="(999999999999999999)" name={name} colMd={colMd} errors={errors} disabled={disabled} onBlur={onBlur}
             value={ value }  onChange={onChange}/>            
            }
        </>
    )
};


export default FieldInputNumeroClabe;